import { render, staticRenderFns } from "./Triangle.vue?vue&type=template&id=bb6b43ca"
import script from "./Triangle.vue?vue&type=script&lang=ts"
export * from "./Triangle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports